import axios, { AxiosResponse } from "axios";

export interface Category {
  OID: number;
  name: string;
  seo_title: string;
  show_category_title: boolean;
  slug: string;
  type: string;
  url: string;
}

export async function getCategories(): Promise<Category[]> {
  try {
    const res: AxiosResponse<Category[]> = await axios.post(
      `${window.API_HOST}/api/categories/list`
    );
    return res.data;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw { status: err.response!.status, errors: err.response!.data.errors };
    } else {
      throw new Error("Cannot request info.");
    }
  }
}
